export default __webpack_public_path__ + "static/media/285hz-Immune-System-Booster.5794820a.ogg";